// Foundations
import { Injectable } from '@angular/core';

// Components
import { PetTileFormInfo } from '../components/interview-request/pet-tile-form/pet-tile-form.component';

// Models
import { FranchiseLocation } from '../models/franchise.model';

@Injectable({
  providedIn: 'root',
})
export class InterviewRequestService {
  private _interviewPetList: PetTileFormInfo[];

  selectedLocation: FranchiseLocation;
  newOptionFromSearch: FranchiseLocation;

  constructor() {}

  // Public Methods
  // ------------------------------------------------------------------------------------

  reset() {
    this.selectedLocation = undefined;
  }

  readInterviewPetList() {
    return this._interviewPetList;
  }

  updateInterviewPetList(list: PetTileFormInfo[]) {
    this._interviewPetList = list;
  }
}
